'use client'

import {LocaleContext} from '@local/stores/contexts'
import {useContext} from 'react'

const useTranslate: () => (key: string) => string = () => {
	const {translations} = useContext(LocaleContext)

	return (value: string) => {
		return (translations?.get?.(value)) || value
	}
}

export default useTranslate
